import GenericListModule from "../generic-list-module";
import {SortDirection} from "../../../data-structures/sort";
import {SortByConfig} from "../../../data-structures/sort/sort-by";

export default class SortByManager {

    public module       : GenericListModule
    private _value      : fieldId | null
    private _direction      : SortDirection | null
    private _isRequired      : boolean

    constructor(module: GenericListModule, currentSortBy: SortByConfig|undefined, isRequired?:boolean) {

        this.module = module;
        this._value         = _.get(currentSortBy, 'fieldId', null);
        this._direction     = _.get(currentSortBy, 'direction', SortDirection.ASC);
        this._isRequired    = !!isRequired;
    }

    set value(fieldId) {
        this._value = fieldId;
        this._updateModule();
    }

    get value() {
        return this._value;
    }

    set direction(direction) {
        this._direction = direction;
        this._updateModule();
    }

    get direction() {
        return this._direction;
    }

    // used in sortOperator
    get sortFields() {
        let res = [];

        if (this._value)
            res.push({
                field           : this._value,
                sortDirection   : this._direction
            });

        if (this.module.config.defaultSortBy)
            res.push({
                field           : this.module.config.defaultSortBy.fieldId,
                sortDirection   : this.module.config.defaultSortBy.direction
            });

        return res;
    }

    setSort(value:fieldId|null, direction:SortDirection|null) {
        this._value = value;
        this._direction = direction;
        this._updateModule();
    }

    toggleSort(value:fieldId) {
        if (this._value !== value) {
            this.setSort(value, SortDirection.ASC);
        } else if (this._direction !== SortDirection.DESC) {
            this.setSort(value, SortDirection.DESC);
        } else if (this._isRequired) {
            this.setSort(value, SortDirection.ASC);
        } else {
            this.setSort(null, null);
        }
    }

    _updateModule() {
        gd.bus.triggerEvent("updateTopPanel");
        this.module.onSortByChanged();

        this.module.data.process();
        this.module.reRender();
    }

    toJSON():any {

        // SortByConfig

        return {
            fieldId     : this.value,
            direction   : this.direction
        }

    }

    /*getFields() {
        // returns fields we can use for grouping

        // rukami zadaem system fields po kotorim mozem
        // this.fields.push('customerCompany');

        // go over custom fields dynamic add
    }*/
}
